type Valuable<T> = {
  [K in keyof T as T[K] extends null | undefined ? never : K]: T[K];
};

export const filterUndefined = <T, V = Valuable<T>>(obj: T): V => {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj ?? {})) {
    if (value !== undefined) {
      result[key] = value;
    }
  }

  return result as V;
};
